export function parseCanSeePermission(...values) {
  for (const value of values) {
    if (value === true || value === 'true' || value === 1 || value === '1') {
      return true;
    }
  }

  for (const value of values) {
    if (value === false || value === 'false' || value === 0 || value === '0') {
      return false;
    }
  }

  return false;
}

export function parseExplicitCanSeePermission(...values) {
  let hasExplicitFalse = false;

  for (const value of values) {
    if (value === true || value === 'true' || value === 1 || value === '1') {
      return true;
    }
  }

  for (const value of values) {
    if (value === false || value === 'false' || value === 0 || value === '0') {
      hasExplicitFalse = true;
    }
  }

  return hasExplicitFalse ? false : undefined;
}
